import { render, staticRenderFns } from "./Alliance.vue?vue&type=template&id=46dd04fa&scoped=true"
import script from "./Alliance.vue?vue&type=script&lang=js"
export * from "./Alliance.vue?vue&type=script&lang=js"
import style0 from "./Alliance.vue?vue&type=style&index=0&id=46dd04fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dd04fa",
  null
  
)

export default component.exports